import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ContentTeam.module.css";

const MINUS = "−";

export const CheckIcon: React.FC = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

/**
 * Predicted minus actual rank, signed: +2 means the team was predicted two places lower than it
 * stands. Colours follow the predict pages (exact / within 2 / further off).
 */
const DeviationChip: React.FC<{ predicted: number; actual: number }> = ({ predicted, actual }) => {
  const { t } = useTranslation("pages");
  const deviation = predicted - actual;
  const distance = Math.abs(deviation);
  const tone = distance === 0 ? styles.chipExact : distance <= 2 ? styles.chipClose : styles.chipFar;
  const title =
    distance === 0
      ? t("contentTeam.chipExact", { predicted, actual })
      : t(deviation > 0 ? "contentTeam.chipLow" : "contentTeam.chipHigh", { predicted, actual, count: distance });
  return (
    <span className={`${styles.chip} ${tone}`} title={title} aria-label={title}>
      {distance === 0 ? <CheckIcon /> : `${deviation > 0 ? "+" : MINUS}${distance}`}
    </span>
  );
};

export default DeviationChip;
